import { Pipe, PipeTransform } from '@angular/core';
import { Contact } from '../../_services';
import { normalizeQuery } from './search-utils';

@Pipe({ name: 'contactFilterByName' })
export class ContactNamePipe implements PipeTransform {
    transform(contacts: Contact[], search: string): any[] {
        if (contacts === undefined || search === '') {
            return contacts;
        }

        return contacts.filter(
            (contact) =>
                this.include(
                    `${contact.firstName} ${contact.lastName}`,
                    search
                ) || this.includeCompany(contact.company, search)
        );
    }

    include(filter: string, search: string) {
        if (!filter) {
            return false;
        }
        return normalizeQuery(filter).includes(normalizeQuery(search));
    }

    includeCompany(company: any, search: string) {
        if (company.length < 1) {
            return false;
        }

        return normalizeQuery(company[0].name).includes(normalizeQuery(search));
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/contact-name.pipe.ts